// Module
var code = "<mx-checkbox ng-required=\"::vm.filter.required\" ng-model=\"vm.value\" data-toggle-mode=\"true\" data-inverted-toggle=\"true\" data-label=\"{{::vm.filter.title}}\"></mx-checkbox>";
// Exports
export default code;